import { formatDate } from '@angular/common';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { 
  OnInit,
  Component,
  QueryList,
  OnDestroy,
  ViewChild,
  ElementRef,
  ViewChildren,
  AfterViewInit, 
  ViewEncapsulation,
  ChangeDetectorRef,
} from '@angular/core';

// environments
import { environment } from 'src/environments/environment';

// packages
import { AnimationOptions } from 'ngx-lottie';

// classes
import UserHandler from 'src/app/core/classes/user-handler';

// custom services ( private )
import { AdOperationService } from 'src/app/core/services/ad/ad-operations/ad-operations.service';

// custom services ( core )
import { GlobleService } from 'src/app/core/services/globle.service';
import { AlertService } from 'src/app/core/services/alert/alert.service';
import { SeoMetaDataService } from 'src/app/core/services/meta-data/seo-meta-data.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

// funcations-helper
import { scrollToElement } from 'src/app/core/funcations-helper/Dom/scroll-to-element';

// directives
import { NgxViewerDirective } from 'src/app/core/directives/ngx-viewer/ngx-viewer.directive';

// custom enums
import { Rent_Type } from 'src/app/core/enums/ads/rent-types';
import { usersType } from 'src/app/core/enums/user/user-type';
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';
import { PAYMENT_TYPE } from 'src/app/core/enums/payment/payment-types';
import { LAYOUTS_TYPE } from 'src/app/core/enums/layouts/layouts-types';
import { SHARE_LINK_TYPE } from 'src/app/core/enums/global/share-link-types';
import { CONTACT_REQUEST_STATUS } from 'src/app/core/enums/contact-request-types';
import { ADVERTISEMENT_TYPE, PRODUCT_TYPE } from 'src/app/core/enums/ads/ads-types';
import { BREAD_CRUMB_TYPE } from 'src/app/shared.modules/shared.components/bread-crumb/enums/types';

// custom interfaces
import { IRega } from 'src/app/core/interfaces/ads/rega';
import { IUserInfo  } from 'src/app/core/interfaces/user/user-info';
import { ITab } from 'src/app/shared.standalone/tabs/interfaces/tab';
import { IRouteParentData } from '../../interfaces/route-parent-data';
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';
import { IMetaDataDeposit } from 'src/app/core/interfaces/payment/meta-data-deposit';
import { IMetaDataAdvertisement } from 'src/app/core/interfaces/payment/meta-data-advertisement';

// custom animations
import { fade } from 'src/app/core/animations/fade';
import { DownFromTop } from 'src/app/core/animations/down-From-top';

// built in InterFace
interface DataRoute {
  key: string
  name: string
  type: PRODUCT_TYPE
  endPoint: string
}


@Component({
  selector: 'app-view-ads',
  templateUrl: './view-ads.component.html',
  styleUrls: ['./view-ads.component.scss'],
  animations: [fade, DownFromTop],
  encapsulation: ViewEncapsulation.None
})
export class ViewAdsComponent implements OnInit, AfterViewInit, OnDestroy {

  // child
  @ViewChild('appNgxViewer') ngxViewer: NgxViewerDirective;
  @ViewChildren('Imgs') public Imgs: QueryList<ElementRef<HTMLImageElement>>

  // init props
  /**
   * @description we have to much subscriptions in this component, then we will pass this field to takeUnit operator to unSubscript from any Observable
   * and emit it inside ngOnDestroy component
   */
  private _destroy$ = new Subject<void>();  

  /**
   * 
   */
  public route_data?: DataRoute
  public RegaAdData: IRega | null  
  public ContentViewTabs: ITab[] = [];
  public CurrentPaymentType: PAYMENT_TYPE
  private route_parent_data: IRouteParentData
  public metaData: IMetaDataDeposit | IMetaDataAdvertisement
  public AdvertisementData: IAdvertisementResponse = null
  public options: AnimationOptions = { path: '/assets/lottie/3d_icon.json'};
  public SliderActive: number = 0
  public CurrentContentActive: number | string = 1
  public openPayment: boolean = false
  public showShareBtn: boolean = false
  public showShareLinks: boolean = false
  public ShowAdvertisementContract: boolean = false
  private _isPermissionOwnerCollapsed: boolean = false 

  constructor(
    public G: GlobleService,
    private _router: Router,
    private Alert: AlertService,
    private route : ActivatedRoute,
    private _seo: SeoMetaDataService,
    private _cdr: ChangeDetectorRef,
    private ADS_SERVICE: AdOperationService,
    private API_RESPONSE: ApiResponseService
  ) { }

  /**
   * 
   */
  ngOnInit(): void {

    /**
     * init
     */
    this.ADS_SERVICE.ngOnInit();

    /**
     * get data is sending from path
     */
    this
      .route
      .parent
      ?.data
      .pipe(takeUntil(this._destroy$))
      .subscribe((res: any) => this.route_parent_data = res);

    /**
     * get params
     */
    this
      .route
      .params
      .pipe(takeUntil(this._destroy$))
      .subscribe(param => this.ADS_SERVICE.cachingMarketingAd(param.id))   

    /**
     * 
     */
    this
      .route
      .data
      .pipe(takeUntil(this._destroy$))
      .subscribe((data: any) =>  {

      // ES6 Destruction
      const { ads, rega } = data;

      /**
       * full route data
       */
      this.route_data = data;

      /**
       * ad Data
       */
      this.AdvertisementData = {...ads};

      // ES6 destructuring
      const { view } = this.route.snapshot.queryParams;      
      const { title, seoTags, seoDescription } = this.AdvertisementData || {};

      // set meta date for seo
      if (title) this._seo.Title = title;
      if (seoTags) this._seo.KeyWords = seoTags;
      if (seoDescription) this._seo.Description = seoDescription;
      
      /**
       * update queryParam
       */
      this.handlerUpdateQueryParam();      

      /**
       * 
       */
      this.AdviceForPublishing();
      
      /**
       * rega data
       */
      this.RegaAdData = rega ? rega : null;
      
      /**
       * handler ad view if not view before or not open as shareLink
       */
      if (!view && !this.G.isMobileDevice) this.ADS_SERVICE.viewAds(this.AdvertisementData);

      /**
       * 
       */
      this.ContentViewTabs = [
        { 
          id: 1,
          title: 'التفاصيل',
          active: true
        },
        { 
          id: 2,
          title: 'خطة الدفع',
          active: this.AdvertisementData.paymentPlan != null && this.AdvertisementData.hasDeposit
        },
        { 
          id: 3,
          title: 'تتبع الانجاز',
          active: this.IsAdvertisementTypeOffPlanSale
        },
      ]      
      
    }); 

  }

  ngAfterViewInit(): void {
    
    /**
     * 
     */
    if (this.G.isMobileDevice) this.showShareLinks = true;

    /**
     * 
     */
    this
      .Imgs
      .changes
      .pipe(takeUntil(this._destroy$))
      .subscribe(_ => this.ngxViewer.instance.update())

  }

  ngAfterViewChecked(): void {
    // this._cdr.detectChanges()
  }

  // getters & setter

  /**
   * userInfo
   */
  public get userInfo(): IUserInfo  | null{
    return this.G.userInfo;
  }

  /**
   * @description check if current auth user his type is normalUser
   */
  public get isTypeUser(): boolean {
    return this.userInfo?.type === usersType.normalUser
  }

  /**
   * @description check if current auth user his Permissions as App Owner
   */
  public get isAppOwner(): boolean {
    return this.userInfo.appOwner
  }

  /**
   * AdvertisementType
   */
  private get _advertisementType(): ADVERTISEMENT_TYPE {
    return this.AdvertisementData?.type
  }

  /**
   * IsAdvertisementOffPlanSale
   */
  public get IsAdvertisementTypeOffPlanSale(): boolean {
    return this._advertisementType === ADVERTISEMENT_TYPE.offPlanSale
  }

  /**
   * IsAdvertisementTypeReady
   */
  public get IsAdvertisementTypeReady(): boolean {
    return this._advertisementType === ADVERTISEMENT_TYPE.Ready
  }  

  /**
   * @description check if owner ad is current auth user
   */
  public get isOwner(): boolean {
    return this.G.CorrectUserId == this.AdvertisementData?.owner?.id
  }

  /**
   * check if owner ad is has MarketPlace
   */
  public get isOwnerHasMarketPlace(): boolean {
    return this.AdvertisementData?.owner?.isMarketPlace
  }

  /**
   * ad Available
   */
  public get isAvailable(): boolean {
    return this.AdvertisementData?.available
  }

  /**
   * SHARE_LINK_TYPE
   */
  public get SHARE_LINK_TYPE(): typeof SHARE_LINK_TYPE {
    return SHARE_LINK_TYPE
  }

  /**
   * isValidAdNumber
   */
  public get isValidAdNumber(): boolean | null {
    
    // ES6 Destruction
    let { endDate } = this.RegaAdData || {};
    const { licenseEndDate } = this.AdvertisementData;

    // change formate date
    if (endDate != null) {
      endDate = endDate.split('/').reverse().join("/");
    }

    // switch between values by nullable operator
    const value = (licenseEndDate ?? endDate) ?? null;

    // change format to javascript contractor Date
    const _formate = formatDate(value, 'MM/dd/yyyy', 'en');
    return this.ADS_SERVICE.isValidAdNumber(_formate);
    
  }

  /**
   * ad saleStarted
   */
  public get saleStarted(): boolean | null {

    try {

      // ES6 Destruction
      const { startSaleDate } = this.AdvertisementData;
  
      /**
       * handler error
       */
      if (startSaleDate == null) throw `startSaleDate is ${startSaleDate}`
      
      /**
       * compare date by millisecond
       */
      return (new Date(startSaleDate).valueOf() - (120 * 60 * 1000)) >= Date.now()
  
      
    }
    catch (err) {
      return null
    }

  }
  
  /**
   * saleStartedAgo
   */
  public get saleStartedAgo(): number | null {

    if (this.saleStarted == false) {

      // ES6 Destruction
      const { startSaleDate } = this.AdvertisementData;   

      /**
       * 
       */
      const avg = Date.now() - (new Date(startSaleDate).valueOf());

      /**
       * calc milliseconds to get days
       */
      const days = Math.floor(avg / 1000 / 60 / 60 / 24);
      
      return days;

    }

    return null;    

  }

  /**
   * 
   */
  public get handlerContactRequestStatus(): { title: string, disabled?: boolean, route?: any[] } {

    try {

      
      // ES6 Destruction
      const { contactRequest, contactRequest: { id, status } } = this.AdvertisementData;
  
      /**
       * 
       */
      switch(status) {
        case CONTACT_REQUEST_STATUS.new:
          return { title: 'تم ارسال طلب تواصل', disabled: true };
        case CONTACT_REQUEST_STATUS.accept:
          return { title: 'استكمال المحادثة', route: ['/info_with_chats', id, 'chats'] };
        case CONTACT_REQUEST_STATUS.complete:
          return { title: 'تم اكمال طلب التواصل', disabled: true };
        default:
          return { title: 'تم اغلاق طلب التواصل', disabled: true };
      }

    }
    catch (err) {
      console.log(err, 'handlerContactRequestStatus')
    }

  }

  /**
   * BREAD_CRUMB_TYPE
   */
  public get BREAD_CRUMB_TYPE(): typeof BREAD_CRUMB_TYPE {
    return BREAD_CRUMB_TYPE
  }

  /**
   * RentTypes
   */
  public get RentTypes(): typeof Rent_Type {
    return Rent_Type
  }  

  /**
   * 
   */
  public get isBuilding(): boolean {

    // ES6 Destruction
    const { category: { type } } = this.AdvertisementData;

    return this.ADS_SERVICE.isBuilding(type);

  }

    /**
   * 
   */
    public get isOffPlanSale(): boolean {

      // ES6 Destruction
      const { category: { type } } = this.AdvertisementData;
  
      return this.ADS_SERVICE.isOffPlanSale(type);
  
    }

  /**
   * 
   */
  public get isPlaning(): boolean {

    // ES6 Destruction
    const { category: { type } } = this.AdvertisementData;

    return this.ADS_SERVICE.isPlaning(type);

  }
  
  /**
   * 
   */
  public get isNormal(): boolean {
    
    // ES6 Destruction
    const { category: { type } } = this.AdvertisementData;

    return this.ADS_SERVICE.isNormal(type);

  }
  
  /**
   * 
   */
  public get cityAndAreaNames(): string {
    
    // ES6 Destruction
    const { city, area } = this.AdvertisementData;

    return this.ADS_SERVICE.handlerCityAndAreaNames(city, area);

  }

  /**
   * 
   */
  public get adTitle(): string {
    
    // ES6 Destruction
    const { title } = this.AdvertisementData;    

    return this.ADS_SERVICE.handlerTitle(title);

  }

  /**
   * @description handler path that will redirect to Build Ad Component,
   * because ad Module can run in other modules, or solo
   */
  public get handlerAdvertisementUpdatePath(): (string | number)[] {

    const path: (string | number)[] = [
      this.route_parent_data.parentUrl ? this.route_parent_data.parentUrl : '',
      'realty-management',
      'edit-realty-advertisement',
      this.AdvertisementData?.id
    ]

    return path;
    
  }
  
  /**
   * isPermissionOwnerCollapsed
   */
  public get isPermissionOwnerCollapsed(): boolean {
    return this._isPermissionOwnerCollapsed
  }
  public set isPermissionOwnerCollapsed(value: boolean) {
    this._isPermissionOwnerCollapsed = value
  }   
  /**
   * src units
   */
  public get units() {
    // ES6 Destruction
    const { units } = this.AdvertisementData;

    if(Array.isArray(units)) return units;
    return [];

  }

  /**
   * buildings
   */
  public get buildings() {
    // ES6 Destruction
    const { buildings } = this.AdvertisementData;

    if(Array.isArray(buildings)) return buildings;
    return [];

  } 
  
  /**
   * AppUrl
   */
  public get AppUrl(): string {
    return environment.APP_URL
  }

  /**
   * SharingUrl
   */
  public get SharingUrl(): string {
    return `${this.AppUrl}/realty-management/view-realty-${this.route_data?.name}/${this.AdvertisementData?.id}`
  }

  // scrollToElement = scrollToElement

  /**
   * @description close PopUp & fire viewAds if user will continue in website 
   */
  public ClosePopUpShareLink(): void {

    /**
     * 
     */
    this.showShareLinks = false;

    /**
     * handler ad view after close Popup if user will continue in website
     */
    if (this.G.isMobileDevice == true) this.ADS_SERVICE.viewAds(this.AdvertisementData);

  }

  /**
   * @description return qrcode as url, from saaei data else return url form rega data else return null
   */
  public get AdLicenseUrl(): string {

    // ES6 Destruction
    const { qrCodeUrl } = this.AdvertisementData;
    const { adLicenseUrl } = this.RegaAdData || {};

    return (qrCodeUrl ?? adLicenseUrl) || null

  }

  /**
   * 
   * @param data 
   * @returns 
   */
  public ChangeContentView(data: ITab): void {


    /**
     * handler null data
     */
    if (data === null) return;

    // ES6 Destruction
    const { id } = data;

    /**
     * handler change with new tab id not current
     */
    if (this.CurrentContentActive != id) this.CurrentContentActive = id;

  }


  /**
   * permissionOwnerToggleCollapsed
   */
  public permissionOwnerToggleCollapsed(): void {
    
    /**
     * toggle boolean
     */
    this.isPermissionOwnerCollapsed = !this.isPermissionOwnerCollapsed

  }

  
  /**
   * Methods
   */

  /**
   * 
   */
  showImgsAlbum() {
    if (this.Imgs.first) this.Imgs.first.nativeElement.click()
  }
  

  /**
   * 
   * @param check 
   */
  toggleStartSaleNotif(check: boolean) {

    // init
    let method: Observable<any> | null = null;

    if (check) method = this.API_RESPONSE.enableStartSaleNotif(this.AdvertisementData?.id, { params: { [RANDOM_VALUE.loader]: true } })
    else method = this.API_RESPONSE.disableStartSaleNotif(this.AdvertisementData?.id, { params: { [RANDOM_VALUE.loader]: true } })

    method.subscribe(res => {

      /**
       * 
       */
      this.AdvertisementData = {...this.AdvertisementData, startSaleNotif: check};

      if (check) {

        this.Alert.show({
          titleBtn: 'موافق',
          type: LAYOUTS_TYPE.alertSucess,
          
          callback: () => this.Alert.hide(),
          msg: `تم تفعيل اشعارات البيع للاعلان رقم ( ${this.AdvertisementData?.id} )`,
        })

      }

    })
    

  }

  private _adAvailabilityToggle(available: boolean) {

    this.API_RESPONSE.putAvailable(this.AdvertisementData?.id, available, {
      params: {
        [RANDOM_VALUE.loader]: true
      }
    }).subscribe(res => {

      this.AdvertisementData = {...this.AdvertisementData, available: available ? false : true}
      
    })

  }

  public handleAdAvailability() {

    
    // ES6 Destructuring
    const { available } = this.AdvertisementData || {};
    
    /**
     * 
     */
    this._adAvailabilityToggle(available);

    // const { hasAdsPackage } = this.userInfo;

    // if (status == STATUS_TYPE.UN_PD) {
    //   this.API_RESPONSE.getBillInfo({
    //     data: {
    //       billType: BILL_TYPE.add
    //     },  
    //   }).subscribe(res => {

    //     this.metaData = {
    //       ...res,
    //       client: 0,
    //       adsId: +this.id,
    //       type: PAYMENT_TYPE.ads,
    //       description: 'اضافة اعلان من المستخدم العادي يتم دفع سعر الاعلان لكي يتم عرضه',
    //     };

    //     //
    //     this.paymentType = PAYMENT_TYPE.ads        

    //     //
    //     this.openPayment = true

    //   })
    // }
    // else {

    //   if (type != usersType.normalUser) {

    //     if (hasAdsPackage) this.toggelAvailableAds(available)
    //     else {
    //       this.Alert.show({
    //         titleBtn: 'موافق',
    //         type: LAYOUTS_TYPE.alertFailure,
    //         callback: () => this.Alert.hide(),
    //         msg: 'لايمكن تغير حالة العقار الي متاح بسبب انتهاء الباقة',
    //       })
    //     }        

    //   }
    //   else this.toggelAvailableAds(available)


    // }

  }

  /**
   * @description for Delete ad
   */
  public deleteAd(): void {

    // ES6 Destruction
    const { id } = this.AdvertisementData;
    
    const req = this.ADS_SERVICE.deleteAd(this.AdvertisementData);

    if (req instanceof Observable) {
      req.subscribe(
        res => this.Alert.show({
          type: LAYOUTS_TYPE.alertInfo,
          msg: `تم حذف الاعلان رقم ( ${id} )`,
          callback: () => {
            this.Alert.hide();
            this._router.navigate(['request_and_realty', 'realty']);
          }
        }),
      )
    }

  }


  /**
   * ToggleShowAdvertisementContract
   * @description show or hide AdvertisementContract
   */
  public ToggleShowAdvertisementContract(): void {
    if (this.AdvertisementData?.contract != null) this.ShowAdvertisementContract = !this.ShowAdvertisementContract
  }

  /**
   * PayProcessing
   * @description to check if AdvertisementData has contract then show contract, else fire PayDeposit direct
   */
  public PayProcessing(): void {

    /**
     * show or hide
     */
    this.ToggleShowAdvertisementContract()

    /**
     * fire PayDeposit after accept contract
     */
    if (!this.ShowAdvertisementContract) this.PayDeposit()

  }
  
  /**
   * 
   */
  public PayDeposit() {
    
    // ES6 Destructuring
    const { type } = this.userInfo || {};
    const { id: adID } = this.AdvertisementData;

    try {
      /**
       * handler cases Error
       */
      if (this.G.CorrectUserId == null) throw 0;
      else if (UserHandler.isUserProfileCompleted(this.G.userInfo) == false || !this.G.userInfo.isVerifiedIdNumber) throw 1;

      /**
       * 
       */
      this.CurrentPaymentType = PAYMENT_TYPE.deposit;

      /**
       * 
       */
      this.API_RESPONSE.depositPay(adID).subscribe(metadata => {

        //
        this.metaData = metadata;

        //
        this.openPayment = true;
  
      })


    } catch (err) {
      
      console.log('depositPayFuncError', err)

      switch(err) {
        case 0:
        default:
          this.Alert.show({
            type: LAYOUTS_TYPE.alertInfo,
            msg: 'يجب عليك تسجيل  الدخول أولأ',
            titleBtn: 'تسجيل الدخول / التسجيل',
            callback: () => {
              this.Alert.hide();
              this._router.navigate(['/sign-in-user'])
            },
          })
          break;
        case 1:
          /**
           * else check user type then redirect to exact route to complete him profile
           */
          if (type == usersType.office) this.G.navigate(['/profile-office'], { realty: true });
          else if (type == usersType.normalUser || type == usersType.superVisor) this.G.navigate(['/profile'], { realty: true });          
          break;
      }

    }

  }

  paymentCallback(res: any) {
    
    this.API_RESPONSE.paymentCallback({...res, paymentType: this.CurrentPaymentType})

  }

  /**
   * 
   * @param AdsInfo data from api ad
   * @param limit limit bars will show with city name
   * @returns total views in ad
   * @deprecated we removed Statistics from View
   */
  setOtherStatistics(AdsInfo: {[key: string]: any}, limit: number) {

    // ES6 Destructuring
    const { statistics, viewersWithoutLocation } = AdsInfo || {}

    let 
      total = viewersWithoutLocation || 0,
      othere = statistics?.slice(limit, statistics?.length);

    othere.map(st => total = total + st.count)
    
    return total

  }

  public get totalCountOfUnits() {
    
    const units = this.AdvertisementData?.units as any[] || [];

    if (units.length > 1) {
      return units.reduce((acc, current) => acc + current.unit?.length, 0);
    }

    return units[0]?.unit?.length

  }

  test(a: any) {
    console.log(a)
  }

  /**
   * HandlerSendContactRequest
   */
  public HandlerSendContactRequest(): void {
    this.ADS_SERVICE
      .HandlerSendContactRequest(this.AdvertisementData)
      ?.subscribe(res => {

        /**
         * 
         */
        const { status } = res;

        /**
         * 
         */
        this.AdvertisementData = {
          ...this.AdvertisementData,
          contactRequest: { ...this.AdvertisementData?.contactRequest, status }
        };        

      })
  }

  /**
   * update queryParam in route for seo
   */
  private handlerUpdateQueryParam(): void {

    // init
    const queryParams = {};

    // ES6 Destruction
    const { title, seoTitle } = this.AdvertisementData;

    /**
     * handler null values
     */
    if (title) queryParams['title'] = title.split(' ').join('-');
    if (seoTitle) queryParams['seoTitle'] = seoTitle.split(' ').join('-');

    /**
     * handler navigate to update queryParams without update url
     */
    this._router.navigate([], {
      queryParams,
      replaceUrl: true,
      relativeTo: this.route,
      queryParamsHandling: 'merge',
    })

  }

  private AdviceForPublishing(): void {

    // ES6 destructuring
    const { totalViews, owner: { id } } = this.AdvertisementData || {};
    
    if (totalViews <= 0 && this.G.CorrectUserId == id) {

      this.Alert.show({
        titleBtn: 'موافق',
        type: LAYOUTS_TYPE.alertInfo,
        
        callback: () => this.Alert.hide(),
        msg: `
          هام جدا: تنصحك ساعي بمشاركة هذه الصفحة
          عبر وسائل التواصل وتطبيقات المراسلة لضمان وصول أكبر قدر من المشاهدين
          لاعلانك العقاري وسيتم استعراضه داخل التطبيق بشكل تلقائي.
          <br />
          من خلال علامة الشير
        `,
      })

      // <a 
      //   class='btn d-block main_color_bg color_white text_under my-3'
      //   href='${environment.APP_URL + '/realty-management/view-realty-' + this.route_data?.name + '/' + this.AdvertisementData?.id}'
      // >
      //   <i class="fa-solid fa-share-nodes fa-xl me-1"></i>
      //   مشاركة هذا الاعلان
      // </a>
      // <a 
      //   class='btn d-block main_color_4th_bg color_white text_under'
      //   href='${environment.APP_URL + '/realty-management/view-realty-' + this.route_data?.name + '/' + this.AdvertisementData?.id}'
      // >
      //   <i class="fa-solid fa-share-nodes fa-xl me-1"></i>
      //   مشاركة قائمة عقاراتي
      // </a>        

    }    

  }
  
  /**
   * 
   * @param elementId 
   */
  public ScrollToElementHandler(elementId: string): void {
    scrollToElement(elementId)
  }

  ngOnDestroy(): void {

    /**
     * destroy all subscriptions in component
     */
    this._destroy$.next();
    this._destroy$.complete();

    /**
     * 
     */
    this.ADS_SERVICE.ngOnDestroy()
  }

}
